import type { Popup } from "@finq/ui/types/popup"

export type InfoPopupProps = Popup & { variant?: "default" | "large" }

export const useInfoPopup = () => {
  const { t } = useI18n({ useScope: "global" })

  const popup = usePopup()

  return (props: InfoPopupProps) => {
    const { classes, action, ...restProps } = props

    return popup.open({
      classes: {
        ...classes,
        modal: {
          ...classes?.modal,
          panel: [
            { "max-h-[720px] max-w-2xl md:max-h-[600px]": props.variant === "large" },
            classes?.modal?.panel,
          ],
        },
        toolbar: ["pt-6", classes?.toolbar],
        content: ["text-sm text-black/75 md:font-light", classes?.content],
        action: ["min-md:grow-0 min-md:w-fit min-md:ms-auto min-md:h-7", classes?.action],
        scrollArea: ["pb-6", { "pb-0": props.variant === "large" }, classes?.scrollArea],
        wrapper: [{ "flex min-h-64 flex-col": props.variant === "large" }, classes?.wrapper],
      },
      ...restProps,

      action: { label: t("common.got_it"), ...action },
    })
  }
}
